// Must match the Insight AI backend (zelp-ai-poc, src/server/routes.ts): it rejects any
// attachment outside these limits with a 400.

export const MAX_ATTACHMENTS = 3;
export const MAX_ATTACHMENT_SIZE_BYTES = 15 * 1024 * 1024;
export const ATTACHMENT_EXTENSIONS = ['.csv', '.xlsx', '.docx', '.pdf', '.png', '.jpg', '.jpeg', '.gif', '.webp'];
export const ATTACHMENT_TYPES_LABEL = 'CSV, XLSX, DOCX, PDF, PNG, JPG, GIF or WEBP';

// Up to this width the drawer covers the whole page (style.scss).
export const MOBILE_MEDIA_QUERY = '(max-width: 768px)';

export const SUGGESTED_PROMPTS = [
    'Summarise CH4 emissions for the last 30 days',
    'Which animals have active health alerts?',
    'Compare average CH4 across my groups',
];

// Insight AI is only offered to these accounts for now.
const ALLOWED_EMAILS = ['demo@zelp.co'];

export const canUseAIChat = user => ALLOWED_EMAILS.includes((user?.email || '').trim().toLowerCase());
